import {defaultHttpResHandler} from "@/store/helpers/defaultHttpResHandler";
import {makeGetReq} from "@/store/helpers/request";
import {appConfig} from "@/lib/appConfig";


export const fetchArticles = async (token, trend, page, limit, name) => await defaultHttpResHandler(async () => await makeGetReq(appConfig.domain + '/articles?trend=' + trend + '&page=' + page + '&limit=' + limit + '&name=' + (name ? name : ''), {token}))

export const fetchCurrentArticle = async (token, id) => await defaultHttpResHandler(async () => makeGetReq(appConfig.domain + '/article/' + id + '?page=0&limit=0', {token}));

export const fetchSimilarArticles = async (token, id) => await defaultHttpResHandler(async () => makeGetReq(appConfig.domain + '/article/similar/' + id, {token}));